<template>
    <div v-if="show && loaded" class="nevs-popup-container">
        <div class="nevs-popup">
            <div class="popup-form">
                <NevsSelect v-model="productId" :ajax="'select/products-no-wares'" :error="validation.product_id"
                            :label="'*' + $LANG.Get('fields.product') + ':'"></NevsSelect>
                <NevsNumberField v-model="quantity" :decimal-places="2" :error="validation.quantity"
                                 :label="'*' + $LANG.Get('fields.quantity') + ':'"></NevsNumberField>
            </div>
            <div class="nevs-popup-buttons">
                <NevsButton class="error" @click="cancelClick()">
                    <i class="fa-solid fa-xmark"></i>
                    {{ $LANG.Get('buttons.cancel') }}
                </NevsButton>
                <NevsButton class="success" @click="okClick()">
                    <i class="fa-solid fa-check"></i>
                    {{ $LANG.Get('buttons.ok') }}
                </NevsButton>
            </div>
        </div>
    </div>
</template>

<script>
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "ModalEditPersonProduct",
    components: {NevsSelect, NevsNumberField, NevsButton},
    props: {
        show: {
            type: Boolean,
            default: false
        },
        personId: {
            type: [Number, String],
            default: null
        },
        personProduct: {
            type: Object,
            default: null
        }
    },
    emits: ['done'],
    data() {
        return {
            loaded: false,
            productId: null,
            quantity: 1,
            validation: {
                product_id: '',
                quantity: ''
            }
        }
    },
    watch: {
        show() {
            this.loaded = false;
            this.validation.product_id = '';
            this.validation.quantity = '';
            if (this.show) {
                if (this.personProduct !== null) {
                    this.productId = this.personProduct.product_id;
                    this.quantity = this.personProduct.quantity;
                } else {
                    this.productId = null;
                    this.quantity = 1;
                }
                this.$nextTick(() => {
                    this.loaded = true;
                });
            }
        }
    },
    methods: {
        cancelClick() {
            this.$emit('done', false);
        },
        okClick() {
            let valid = true;
            if (this.productId === null) {
                this.validation.product_id = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.product_id = '';
            }
            if (this.quantity === '' || this.quantity === null || this.quantity <= 0) {
                this.validation.quantity = this.$LANG.Get('labels.mandatoryField');
                valid = false;
            } else {
                this.validation.quantity = '';
            }
            if (!valid) {
                return;
            }

            let vm = this;
            let method = this.personProduct === null ? 'post' : 'put';
            let action = this.personProduct === null
                ? 'person-products'
                : 'person-products/' + this.personProduct.id;
            this.$API.APICall(method, action, {
                person_id: this.personId,
                product_id: this.productId,
                quantity: this.quantity
            }, (data, success) => {
                if (success) {
                    vm.$emit('done', true);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped>
.nevs-popup {
    max-width: 500px;
}

.popup-form {
    padding: 10px;
}
</style>
